const sanitize = (str) => {
    return str
        .replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
        .replace(/[^0-9]/g, '');
};

const main = () => {
    const targets = document.querySelectorAll('input[name="tel"], input[name="zip"]');
    if (!targets.length) return;

    targets.forEach((input) => {
        let composing = false;

        input.addEventListener('compositionstart', () => { composing = true; });
        input.addEventListener('compositionend', () => {
            composing = false;
            // compositionend後に整形
            input.value = sanitize(input.value);
        });

        // blurで最終整形（メインのサニタイズ）
        input.addEventListener('blur', () => {
            input.value = sanitize(input.value);
        });

        // inputイベントではIME中はスキップ
        input.addEventListener('input', () => {
            if (composing) return;
            const converted = sanitize(input.value);
            if (converted !== input.value) {
                const pos = input.selectionStart;
                const diff = input.value.length - converted.length;
                input.value = converted;
                input.setSelectionRange(pos - diff, pos - diff);
            }
        });
    });
};

export default main;
